export default {
  "content": "<path d=\"M9.263 14c-.15 0-.26-.04-.33-.069-.15-.068-.49-.293-.49-.9v-2.704h-.43a10.318 10.318 0 00-6.787 2.978.984.984 0 01-.11.107c-.33.324-.65.226-.77.167s-.39-.235-.34-.715c.02-.255.07-.51.13-.764.75-3.164 3.899-6.426 7.877-6.426h.44V2.971c0-.607.35-.833.49-.901.15-.069.55-.186 1.04.225l5.547 4.75c.28.216.47.579.47.96 0 .383-.18.745-.49.98l-5.518 4.721c-.28.235-.53.294-.72.294h-.01zm.18-4.662v3.526L14.86 8.22c.09-.069.12-.147.12-.215a.29.29 0 00-.1-.206L9.442 3.137v3.517H8.004c-3.339 0-6.008 2.654-6.807 5.328a11.334 11.334 0 016.787-2.644h1.46z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};